import { useMemo } from 'react'
import { WppInput, WppListItem, WppSelect, WppTextareaInput, WppTypography } from '@wppopen/components-library-react'
import FormAccordionSection from 'components/FormAccordionSection/FormAccordionSection'
import { unknown } from 'utils/constants'
import type { ProductsDetailDataV5 } from 'utils/utils.d'
import styles from './StandardContent.module.scss'

interface StandardContentFiltered {
  variantId?: string
  content?: ProductsDetailDataV5['standard_content']
}
interface StandardContentProps {
  productData?: ProductsDetailDataV5
}

export default function StandardContent({ productData }: StandardContentProps) {
  const { variantId, content } = useMemo(() => {
    const standardContent: StandardContentFiltered = {
      variantId: undefined,
      content: undefined,
    }

    if (productData?.standard_content?.length) {
      standardContent.content = productData.standard_content
    } else if (productData?.variants?.length) {
      const masterVariant = productData?.variants?.find(variant => variant.master)
      standardContent.variantId = masterVariant?.variant_id
      standardContent.content = masterVariant?.standard_content?.length ? masterVariant?.standard_content : undefined
    }

    return standardContent
  }, [productData?.standard_content, productData?.variants])

  return (
    <div className={styles.container} data-testid="standard-content">
      {!content ? (
        <WppTypography tag="h3" type="s-strong" data-testid="empty-standard-content" className={styles.empty}>
          You have not uploaded any standard content for the product
        </WppTypography>
      ) : (
        <div className={styles.formContainer}>
          {variantId && (
            <WppSelect
              labelConfig={{ text: 'Variant ID' }}
              value={variantId}
              required
              disabled
              data-testid="apply-style-guide-select"
            >
              <WppListItem value={variantId} data-testid="select-item" multiple={false}>
                {variantId}
              </WppListItem>
            </WppSelect>
          )}

          {content.map(({ content_type_id, content_type_title, content }: any) => {
            const title = content_type_title
              ? content_type_title.charAt(0).toUpperCase() + content_type_title.slice(1)
              : unknown

            return (
              <FormAccordionSection
                key={content_type_id}
                text={title}
                fullWidthChildren={
                  <div>
                    {Array.isArray(content) ? (
                      content.map((item, index) => (
                        <WppInput
                          key={index}
                          labelConfig={{ text: `${title} ${index + 1}` }}
                          required
                          disabled
                          value={item || ''}
                        />
                      ))
                    ) : (
                      <>
                        {content_type_title === 'desc' ? (
                          <WppTextareaInput labelConfig={{ text: title }} required disabled value={content || ''} />
                        ) : (
                          <WppInput labelConfig={{ text: title }} required disabled value={content || ''} />
                        )}
                      </>
                    )}
                  </div>
                }
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
